export default function({ rootState, dispatch, commit }, data) {
    commit('startedAuthentication')
    // POST /auth/login
    return dispatch('post', {
        url: '/provider/auth/verify',
        data,
        headers: {
            'Authorization': data.token
        }
    }, {
        root: true
    })
    .then((result) => {
        commit('finishedAuthentication')
        console.log(result)
        rootState.auth.id = result.payload.id
        if(result.payload.cp)
            return {
                set_password: true
            }
    })
    .catch((error) => {
        commit('finishedAuthentication')
        commit('failedValidation')
        throw error
    })
}
